(function () {
  if (window.__dropplierSearchGimmicksInit) return;
  window.__dropplierSearchGimmicksInit = true;

  const PLACEHOLDERS = [
    'Search Dropplier',
    'Try kitchen finds…',
    'Search home products…',
    'Find wholesale deals…',
    'Browse from ₹99…',
  ];

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initPlaceholderCycle = (input) => {
    if (input.dataset.dpPlaceholderInit || prefersReducedMotion) return;
    input.dataset.dpPlaceholderInit = 'true';

    const defaultPlaceholder = input.getAttribute('placeholder') || PLACEHOLDERS[0];
    let index = 0;

    const tick = () => {
      if (document.activeElement === input || input.value.trim() !== '') return;
      index = (index + 1) % PLACEHOLDERS.length;
      input.setAttribute('placeholder', PLACEHOLDERS[index]);
    };

    setInterval(tick, 3200);
    input.addEventListener('focus', () => input.setAttribute('placeholder', defaultPlaceholder));
    input.addEventListener('blur', () => {
      if (input.value.trim() === '') input.setAttribute('placeholder', PLACEHOLDERS[index]);
    });
  };

  const initSearchBar = (root) => {
    const bar = root.querySelector('.dropplier-header-search__bar');
    const input = root.querySelector('.dropplier-header-search__input');
    if (!bar || !input) return;

    initPlaceholderCycle(input);

    bar.addEventListener('focusin', () => bar.classList.add('is-dp-search-focused'));
    bar.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (!bar.contains(document.activeElement)) bar.classList.remove('is-dp-search-focused');
      });
    });
  };

  document.querySelectorAll('[data-dropplier-header-search]').forEach(initSearchBar);
})();
